import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { SegmentosComponent } from './segmentos.component';

import { SegmentoFinanceiroModule } from './pages/segmento-financeiro/segmento-financeiro.module';
import { SegmentoSaudeModule } from './pages/segmento-saude/segmento-saude.module';
import { SegmentoSegurosModule } from './pages/segmento-seguros/segmento-seguros.module';
import { SegmentoVarejoModule } from './pages/segmento-varejo/segmento-varejo.module';
import { SegmentoSetorPublicoModule } from './pages/segmento-setor-publico/segmento-setor-publico.module';
import { SegmentoEducacaoModule } from './pages/segmento-educacao/segmento-educacao.module';
import { SegmentoMercadoGraficoModule } from './pages/segmento-mercado-grafico/segmento-mercado-grafico.module';

import { NavegacaoModule } from '../plataforma/components/navegacao/navegacao.module';

@NgModule({
    declarations: [
        SegmentosComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
      
        SegmentoFinanceiroModule,
        SegmentoSaudeModule,
        SegmentoSegurosModule,
        SegmentoVarejoModule,
        SegmentoSetorPublicoModule,
        SegmentoEducacaoModule,
        SegmentoMercadoGraficoModule,

        NavegacaoModule
    ],
    exports: [
        SegmentosComponent
    ]
})

export class SegmentosModule { }
